import { render, staticRenderFns } from "./CustDataViewPermissionModal.vue?vue&type=template&id=56a0f256&scoped=true"
import script from "./CustDataViewPermissionModal.vue?vue&type=script&lang=js"
export * from "./CustDataViewPermissionModal.vue?vue&type=script&lang=js"
import style0 from "./CustDataViewPermissionModal.vue?vue&type=style&index=0&id=56a0f256&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a0f256",
  null
  
)

export default component.exports